import notes from "./user_notes";
import auth from "./user_auth";
import config from "./user_config";
import infoo from "../plugins/infoo";
import Vue from "vue";

const user = {
  namespaced: true,
  modules: { auth, config, notes },
  state: {
    licenses: {
      __: {
        id: "",
        ini: "",
        fin: "",
        sta: "",
        tipo: ""
      }
    }
  },
  getters: {
    hasActivePlan() {
      // TODO: evaluar el acceso y la licencia
      // se calculan unos días gratis de prueba, ese datos está en los parámetros en milisegundos
      // en los datos del usuario se registra la fecha de su registro
      // otra fecha sera cuando expira su licencia
      return true;
    },
    licenciaActiva(state) {
      let licenId = state.config._licenId || "__";
      return state.licenses[licenId];
    }
  },
  mutations: {
    setLicense(state, licen) {
      Vue.set(state.licenses, licen.id, licen);
      this.$local.set("user/licenses/" + licen.id, licen);
    }
  },
  actions: {
    createInvitedLicencse({ commit, rootGetters }) {
      let t = rootGetters["app/trad/activa"];
      let params = rootGetters["app/params"];
      let hoy = infoo.hoy;

      // calculamos la fecha maxima || lanzamiento o diasGratis
      let mayo20 = new Date(2020, 4, 20, 0, 0, 0, 0);
      let diasGratis = params.licen.diasGratis || 7;
      diasGratis = diasGratis * 24 * 60 * 60 * 1000;
      let fechaGratis = new Date(hoy.fecha.getTime() + diasGratis);
      let fMax = mayo20 > fechaGratis ? mayo20 : fechaGratis;

      // creamos la licencia
      let lic = {
        id: "__",
        ini: hoy.iso,
        fin: fMax.toISOString().slice(0, 10),
        sta: t.licen.activa, // Test | Activa | Inactiva | Caduca
        tipo: t.licen.tipoGratuita // Gratuita Invitado | Gratuita Comunidad | Gratuita Socio | Distribuidor | Suscripción
      };
      commit("setLicense", lic);
    },
    getLicense({ commit, getters }) {
      let uid = getters.auth.uid;
      let license = this.$local.get("user/licenses/" + uid);
      if (license) {
        commit("setLicense", license);
      }

      return;
    }
  }
};

export default user;
